import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { getContent } from '@/utils/helper';

import { analytics, getClickSocialDetail } from '@/utils/analytics';

import Text from '@/atoms/Text/Text';
import Icon from '@/atoms/Icon/Icon';

function SocialAggreagtor({ entries, fields }) {
  const { title, socialLinks: socials, id } = fields;
  const [initialized, setInitialized] = useState(false);
  const [screenWidth, setScreenWidth] = useState(0);
  const initTimer = useRef(null);
  const resizeTimer = useRef(null);

  const socialLinks = socials?.length
    ? socials.map((social) => getContent(social.sys.id, entries))
    : [];

  //load curator.io script if not already exist
  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (isScriptExist) {
        setInitialized(false);
        isScriptExist.remove();
      }

      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.id = id;
      script.onload = function () {
        if (callback) callback();
      };
      document.body.appendChild(script);

      if (callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL(
      'curator-io',
      'https://cdn.curator.io/published/13a09dc0-8cb4-4c9a-b988-4bae5b564112.js',
      () => {
        //set timer to check if all images has been loaded, then initialize (apply css class)
        let imagesLoaded = [];
        clearInterval(initTimer.current);
        initTimer.current = setInterval(() => {
          const images = document.querySelectorAll('.crt-feed .crt-post-image');
          if (images) {
            for (let i = 0; i < images.length; i++) {
              //check if image has been loaded
              const imgSrc = images[i].getAttribute('src');
              const img = new Image();
              img.src = imgSrc;
              img.onload = function () {
                if (imagesLoaded.indexOf(imgSrc) === -1) {
                  imagesLoaded.push(imgSrc);
                }
              };
            }

            if (imagesLoaded.length >= 4) {
              clearInterval(initTimer.current);
              setTimeout(() => {
                setInitialized(true);
              }, 1000);
            }
          }
        }, 500);
      }
    );

    return () => clearInterval(initTimer.current);
  }, []);

  //on window resize change screenWidth state value
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //toggle initialized when window width changed
  useEffect(() => {
    if (screenWidth !== 0) {
      clearTimeout(resizeTimer.current);
      setInitialized(false);
      resizeTimer.current = setTimeout(() => {
        setInitialized(true);
      }, 1000);
    }
  }, [screenWidth]);

  return (
    <div
      className={`${
        initialized ? 'aaco-social-aggregator' : ''
      } container mx-auto`}
      id={id}
    >
      <div className="flex flex-col md:flex-row justify-between md:items-center mb-10 md:mb-[60px] gap-y-5 md:gap-y-0">
        <Text tag={'h4'} style={'text-progressive-blue'}>
          {title}
        </Text>
        {socialLinks.length && (
          <ul className="mb-0 p-0 flex md:justify-center md:items-center gap-x-[10px]">
            {socialLinks.map((link, index) => (
              <li key={index} className="block">
                <a
                  href={link.fields?.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={link.fields?.name}
                  onClick={(e) => {
                    analytics({
                      window,
                      document,
                      detail: getClickSocialDetail(e, {
                        url: link.fields?.link,
                        platform: link.fields?.name,
                      }),
                    });
                  }}
                  className="flex flex-col text-progressive-blue justify-center items-center cursor-pointer"
                >
                  <Icon
                    name={link.fields?.icon}
                    className="block"
                    width={40}
                    height={40}
                  />
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div id="curator-feed-default-feed-layout">
        <a
          href="https://curator.io"
          rel="noopener noreferrer"
          target="_blank"
          className="crt-logo crt-tag"
        >
          Powered by Curator.io
        </a>
      </div>
    </div>
  );
}

SocialAggreagtor.propTypes = {
  assets: PropTypes.array,
  entries: PropTypes.array,
  fields: PropTypes.object,
};

SocialAggreagtor.defaultProps = {
  assets: [],
  entries: [],
  fields: {},
};

export default SocialAggreagtor;
